@if (loading || submitting | async) {
    <div class="d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="container mb-5">
        <div class="w-fit">
            <app-back-button routerLink="/reservations" component="Reservations"></app-back-button>
        </div>
        <div class="d-flex align-items-center mt-3">
            <div class="col-lg-4 col-12">
                <h1>Reservation Entry</h1>
            </div>
        </div>
        <div class="row my-5">
            <mat-accordion>
                <app-reservation-basic-information-step 
                    [basicInformationForm]="basicInformationForm" 
                    [organizations]="organizations"
                    (departureDateEvent)="updatePolicyAfterReservationChange($event)"
                    (selectedOrgIdEvent)="getSelectedOrgPolicies($event)">
                </app-reservation-basic-information-step>
                <app-guests-step *ngIf="organizationId && !invalidForm"
                    [guestsForm]="guestsForm" 
                    [existingReservationGuests]="existingReservationGuests"
                    [existingReservationGuestCount]="existingReservationGuestCount"
                    [verificationPackage]="verificationPackage" 
                    [countries]="countries" 
                    (guestsAdded)="guestsAdded($event)"
                    (numberOfGuestsChanged)="handleNumberOfGuestsChanged($event)">
                </app-guests-step>
                <app-property-step *ngIf="organizationId && !invalidForm"
                    (onPropertySelected)="onPropertySelected($event)"
                    [existingProperty]="existingProperty"
                    [organizationId]="organizationId">
                </app-property-step>
                <app-review-all *ngIf="organizationId && !invalidForm"
                    [policyTableData]="selectedPrimaryPolicy" 
                    [primaryPolicyPricingModel]="primaryPolicyPricingModel"
                    [verificationCost]="verificationCost" 
                    [verificationPackage]="verificationPackage" 
                    [insuranceCost]="insuranceCost"
                    [insurancePolicyPrice]="insurancePolicyPrice"
                    [numberOfNightsFrom]="numberOfNightsFrom"
                    [numberOfNightsTo]="numberOfNightsTo"
                    [extraNights]="extraNights"
                    [extraNightsPrice]="extraNightsPrice">
                </app-review-all>
            </mat-accordion>
        </div>
        <div class="mt-2 mb-2 d-flex justify-content-end">
            <button mat-raised-button class="finish-button" (click)="onCancelClick()">
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
            <button mat-raised-button class="action-button submit-reservation-button"
                [disabled]="!canCreateReservation()" (click)="submitReservation()">
                <mat-icon>check</mat-icon>
                Submit Reservation
            </button>
        </div>
        <mat-action-row *ngIf="!canCreateReservation()" class="mt-4 d-flex justify-content-end">
            <div class="d-flex justify-content-end align-items-center text-muted">
                <span class="required-input">**</span>&nbsp;- Required fields before submitting Reservation
            </div>
        </mat-action-row>
    </div>
}